import type { CareerMovePriority } from "@career-ops-amplify/shared";

export function formatDue(dueAt?: string): string {
  if (!dueAt) return "No due date";
  const d = new Date(dueAt);
  if (Number.isNaN(d.getTime())) return "No due date";
  const now = Date.now();
  const diff = d.getTime() - now;
  const days = Math.round(diff / 86_400_000);
  if (days < 0) return `${Math.abs(days)}d overdue`;
  if (days === 0) return "Due today";
  if (days === 1) return "Due tomorrow";
  return `Due in ${days}d`;
}

export function priorityLabel(priority: CareerMovePriority | string): string {
  switch (priority) {
    case "critical":
      return "Critical";
    case "high":
      return "High";
    case "low":
      return "Low";
    default:
      return "Normal";
  }
}

export const BUCKET_LABELS: Record<string, string> = {
  ALL_ACTIVE: "All",
  ACT_NOW: "Act now",
  REPLY_NEEDED: "Reply needed",
  READY_TO_ADVANCE: "Ready to advance",
  AT_RISK: "At risk",
  WAITING: "Waiting",
  NURTURE: "Nurture",
};

export const NOT_RIGHT_REASONS = [
  "Not relevant right now",
  "Wrong timing",
  "Wrong role family",
  "Already handled",
  "Bad recommendation",
];
